import { Component, Inject, inject, EventEmitter, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { Account } from '../../../../../../service/account.service';
import { AdminService } from '../../../../../../service/admin.service';

@Component({
  selector: 'app-edit-user-vrchat',
  imports: [
    MatDialogModule, 
    MatButtonModule, 
    MatListModule, 
    MatFormFieldModule, 
    MatInputModule,
    FormsModule
  ],
  templateUrl: './edit-user-vrchat.component.html',
  styleUrl: './edit-user-vrchat.component.less'
})
export class EditUserVrchatComponent {
  dialog = inject(MatDialog);
  private dialogRef = inject(MatDialogRef);
  adminService = inject(AdminService);
  
  data?: Account;
  
  @Output() userUpdated = new EventEmitter<Account>();

  constructor (
    @Inject(MAT_DIALOG_DATA) private _data: { user: Account }
  ) {
    this.data = structuredClone(this._data.user);
    
    // Ensure vrchat connection exists for editing
    if (!this.data.connections.vrchat) {
      this.data.connections.vrchat = {
        id: '',
        username: '',
        avatar: ''
      };
    }
    
    console.log(this.data);
  }

  save() {
    if (this.data) {
      this.adminService.patchUser(this.data).subscribe((data: any) => {
        console.log(data);
        if (data.code == 200) {
          // Emit the updated user data to the parent
          this.userUpdated.emit(this.data);
          this.dialogRef.close();
        } else {
          alert(data.message);
        } 
      });
    } else {
      alert("Something went wrong")
    }
  }
}
